
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { DataTransferObject_AcceptAssignmentNotificationDto, DataTransferObject_AddNotificationImageDto, ImageRole, DataTransferObject_RejectAssignmentNotificationDto, AssignmentNotificationId } from "../../Shared/AssignmentNotification.js";
import { FormState__startLoading, FormState__setValidationResponse_5219762A, RequestedValue$1, FormState_get_empty } from "../../Shared/Shared.js";
import { add, tryFind, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { equals, comparePrimitives, compareArrays } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { acceptNotification, addImage, removeImage, rejectNotification, getNotificationDetail, getMailNotification } from "../../Requests/AssignmentNotification.js";
import { singleton as singleton_1, tryFind as tryFind_1, tryPick, empty as empty_1, choose, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { receiverFilesByEntity, withPendingUploads } from "../../Widgets/Helper.js";
import { difference, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { collect, singleton, empty as empty_2, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Cmd_uploadSignature, Cmd_uploadImage } from "../../Requests/Files.js";

function assignmentNotificationId(notificationId) {
    return new AssignmentNotificationId(parse(notificationId));
}

export function init(notificationId) {
    return [new State(notificationId, FormState_get_empty(), new RequestedValue$1(0, []), new RequestedValue$1(0, []), empty({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), undefined, undefined), Cmd_batch(ofArray([getMailNotification(assignmentNotificationId(notificationId), (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(13, [Item_1]))), getNotificationDetail(assignmentNotificationId(notificationId), (Item_2) => (new Msg(5, [Item_2])), (Item_3) => (new Msg(13, [Item_3])))]))];
}

export function update(msg, state) {
    let xs, xs_2, matchValue_5;
    switch (msg.tag) {
        case 2: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.NotificationId, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.NotificationId, FormState_get_empty(), state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), (xs = ["accept-email-notification", "success"], Cmd_ofEffect((_arg) => {
                    RouterModule_nav(ofArray(xs), 1, 1);
                }))]))];
            }
        }
        case 3: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.NotificationId, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.NotificationId, FormState_get_empty(), state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), (xs_2 = ["accept-email-notification", "rejected"], Cmd_ofEffect((_arg_1) => {
                    RouterModule_nav(ofArray(xs_2), 1, 1);
                }))]))];
            }
        }
        case 1: {
            const dto_1 = new DataTransferObject_RejectAssignmentNotificationDto(undefined);
            return [new State(state.NotificationId, FormState__startLoading(state.FormState), state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl), rejectNotification(assignmentNotificationId(state.NotificationId), dto_1, (Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(13, [Item_3])))];
        }
        case 4:
            return [new State(state.NotificationId, state.FormState, new RequestedValue$1(1, [msg.fields[0]]), state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl), Cmd_none()];
        case 5: {
            const detail = msg.fields[0];
            return [new State(state.NotificationId, state.FormState, state.AcceptEmailNotificationDetail, new RequestedValue$1(1, [detail]), withPendingUploads(state.SelectedReceiverFilesByEntity, receiverFilesByEntity(detail)), state.Signature, state.SignatureUrl), Cmd_none()];
        }
        case 6: {
            const newFiles = msg.fields[2];
            const entityType = msg.fields[0];
            const entityId = msg.fields[1];
            const entityKey = [entityType, entityId];
            const previousUrls = ofList(choose((file) => {
                if (file.tag === 1) {
                    return file.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, defaultArg(tryFind(entityKey, state.SelectedReceiverFilesByEntity), empty_1())), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
            const newUrls = ofList(choose((file_1) => {
                if (file_1.tag === 1) {
                    return file_1.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, newFiles), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            });
            const pickedFile = tryPick((file_2) => {
                if (file_2.tag === 0) {
                    return file_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            const removedUrls = difference(previousUrls, newUrls);
            const cmds = toList(delay(() => {
                let matchValue_2, file_3, formData;
                return append((matchValue_2 = pickedFile, (matchValue_2 == null) ? (empty_2()) : ((file_3 = matchValue_2, (formData = (new FormData()), (formData.append(file_3.name, file_3), singleton(Cmd_uploadImage((response_2) => (new Msg(7, [entityType, entityId, response_2])), (Item_4) => (new Msg(13, [Item_4])), formData))))))), delay(() => collect((url_1) => {
                    let matchValue_3;
                    const matchValue_1 = state.Detail;
                    matchValue_3 = ((matchValue_1.tag === 0) ? undefined : map((image_1) => image_1.Id, tryFind_1((image) => {
                        if ((equals(image.Role, new ImageRole(1, [])) && equals(image.EntityType, entityType)) && (image.EntityId === entityId)) {
                            return image.ImageUrl === url_1;
                        }
                        else {
                            return false;
                        }
                    }, matchValue_1.fields[0].Images)));
                    if (matchValue_3 == null) {
                        return empty_2();
                    }
                    else {
                        const imageId = matchValue_3;
                        return singleton(removeImage(assignmentNotificationId(state.NotificationId), imageId, (Item_5) => (new Msg(9, [Item_5])), (Item_6) => (new Msg(13, [Item_6]))));
                    }
                }, removedUrls)));
            }));
            return [new State(state.NotificationId, state.FormState, state.AcceptEmailNotificationDetail, state.Detail, add(entityKey, newFiles, state.SelectedReceiverFilesByEntity), state.Signature, state.SignatureUrl), Cmd_batch(cmds)];
        }
        case 7: {
            const response_3 = msg.fields[2];
            switch (response_3.tag) {
                case 0:
                    return [state, Cmd_batch(ofArray([getNotificationDetail(assignmentNotificationId(state.NotificationId), (Item_9) => (new Msg(5, [Item_9])), (Item_10) => (new Msg(13, [Item_10]))), Cmd_errorToast("general.file_too_large")]))];
                case 2:
                    return [state, Cmd_batch(ofArray([getNotificationDetail(assignmentNotificationId(state.NotificationId), (Item_11) => (new Msg(5, [Item_11])), (Item_12) => (new Msg(13, [Item_12]))), Cmd_errorToast("general.a_error_occured")]))];
                default:
                    return [state, addImage(assignmentNotificationId(state.NotificationId), new DataTransferObject_AddNotificationImageDto(msg.fields[0], msg.fields[1], new ImageRole(1, []), response_3.fields[0].ImageUrl), (Item_7) => (new Msg(8, [Item_7])), (Item_8) => (new Msg(13, [Item_8])))];
            }
        }
        case 8:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_batch(ofArray([getNotificationDetail(assignmentNotificationId(state.NotificationId), (Item_15) => (new Msg(5, [Item_15])), (Item_16) => (new Msg(13, [Item_16]))), Cmd_errorToast("general.a_error_occured")]))];
            }
            else {
                return [state, getNotificationDetail(assignmentNotificationId(state.NotificationId), (Item_13) => (new Msg(5, [Item_13])), (Item_14) => (new Msg(13, [Item_14])))];
            }
        case 9:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_batch(ofArray([getNotificationDetail(assignmentNotificationId(state.NotificationId), (Item_19) => (new Msg(5, [Item_19])), (Item_20) => (new Msg(13, [Item_20]))), Cmd_errorToast("general.a_error_occured")]))];
            }
            else {
                return [state, getNotificationDetail(assignmentNotificationId(state.NotificationId), (Item_17) => (new Msg(5, [Item_17])), (Item_18) => (new Msg(13, [Item_18])))];
            }
        case 10:
            return [new State(state.NotificationId, state.FormState, state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, msg.fields[0], state.SignatureUrl), Cmd_none()];
        case 11: {
            const matchValue_4 = state.Signature;
            if (matchValue_4 == null) {
                return [state, Cmd_none()];
            }
            else {
                const signature = matchValue_4;
                const formData_1 = new FormData();
                formData_1.append(signature.name, signature);
                return [new State(state.NotificationId, FormState__startLoading(state.FormState), state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, undefined), Cmd_uploadSignature(formData_1, (Item_21) => (new Msg(12, [Item_21])), (Item_22) => (new Msg(13, [Item_22])))];
            }
        }
        case 12: {
            const response_6 = msg.fields[0];
            switch (response_6.tag) {
                case 0:
                    return [state, Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [state, Cmd_errorToast("general.a_error_occured")];
                default:
                    return [new State(state.NotificationId, state.FormState, state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, response_6.fields[0].ImageUrl), singleton_1((dispatch) => {
                        dispatch(new Msg(0, []));
                    })];
            }
        }
        case 13:
            return [new State(state.NotificationId, FormState_get_empty(), state.AcceptEmailNotificationDetail, state.Detail, (matchValue_5 = state.Detail, (matchValue_5.tag === 0) ? empty({
                Compare: (x_2, y_2) => (compareArrays(x_2, y_2) | 0),
            }) : receiverFilesByEntity(matchValue_5.fields[0])), state.Signature, state.SignatureUrl), Cmd_errorToast("general.a_error_occured")];
        default:
            if (state.AcceptEmailNotificationDetail.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dto = new DataTransferObject_AcceptAssignmentNotificationDto(undefined, state.SignatureUrl);
                return [new State(state.NotificationId, FormState__startLoading(state.FormState), state.AcceptEmailNotificationDetail, state.Detail, state.SelectedReceiverFilesByEntity, state.Signature, state.SignatureUrl), acceptNotification(assignmentNotificationId(state.NotificationId), dto, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(13, [Item_1])))];
            }
    }
}

